import { Link, useLocation } from "react-router-dom";
import API from "../Network/API";
import { useEffect, useState } from "react";
import PostLoader from '../assets/loader.gif';
import moment from "moment";
import toast from "react-hot-toast";
import { useTranslation, Trans } from "react-i18next";
export default function OrderComplete() {
    const { t } = useTranslation();
    const location = useLocation();
    const isAppRoute = location.pathname.startsWith("/app");
    const queryParams = new URLSearchParams(location.search);
    const redirect_status = queryParams.get('redirect_status');
    const payment_intent = queryParams.get('payment_intent');
    // paid orders come back with the Stripe Checkout Session id; free ones with payment_intent=free_checkout
    const session_id = queryParams.get('session_id');
    const data = JSON.parse(localStorage.getItem("data_checkout"));
    const [isLoading, setLoading] = useState(false);
    const [pay_status, setPayStatus] = useState(false)
    const [error_status, setErrorStatus] = useState(false)
    const [errors, setError] = useState()
    const [order, setOrder] = useState()
    useEffect(() => {
        if(!localStorage.getItem('data_checkout')){
            if(isAppRoute){
                window.location.href = '/app';
            }else{
                window.location.href = '/';
            }
            
        }
        if (session_id || (redirect_status == 'succeeded' && payment_intent == 'free_checkout')) {
             submitOrder();
        } else {
            setErrorStatus(true)
        }
    }, [redirect_status, session_id]);

    const submitOrder = () => {
        setLoading(true)
        const event = JSON.parse(localStorage.getItem("event"));
        const orderDetails = {
            course_id: data?.course_id,
            lesson_id: data?.lesson_id,
            teacher_id: data?.teacher_id,
            timezone: data?.timezone,
            checkout_session_id: session_id,
            duration: 0,
            start_time: event?.start?moment.tz(event?.start, data?.timezone).format('YYYY-MM-DD hh:mm'):null,
            end_time:  event?.start?moment.tz(event?.end, data?.timezone).format('YYYY-MM-DD hh:mm'):null,
        };
        API.post(`/v1/oauth/order/save`, orderDetails)
            .then(response => {
                setPayStatus(true)
                setLoading(false)
                setOrder(response.data.data)
                setErrorStatus(false)
                
                localStorage.removeItem('data_checkout');
                localStorage.removeItem('event');
                localStorage.removeItem('lesson');
            })
            .catch(error => {
                setLoading(false)
                setPayStatus(false)
                setErrorStatus(true)
                toast.error(error?.response?.data?.message || t('orderComplete.something_went_wrong'))
            });

    }
    return (
        <>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '80vh',
                margin: 'auto',
                padding: 'auto'
            }}>
                <div className="card" style={{
                    padding: '20px',
                    textAlign: 'center'
                }}>
                    {error_status ?
                        <>
                            <h4>{t("orderComplete.order_not_completed")}</h4>
                            <p>{t("orderComplete.purchase_not_completed")}</p>
                            <p><Link to={isAppRoute ? '/app/all-courses' : '/all-courses'}>{t("orderComplete.back_to_courses")}</Link></p>
                        </> :
                        <></>
                    }
                    {!error_status && !pay_status ?
                        <>
                            <h4>{t("orderComplete.payment_processing")}</h4>
                            <p><Trans i18nKey="orderComplete.please_wait" /></p>
                            <p><img src={PostLoader} alt={t('orderComplete.post_loader')} height={80} width={80} /></p>
                        </>
                        :
                        <>
                            <h4 className="text-uppercase" style={{ letterSpacing: '3px' }}>{t("orderComplete.thank_you")}</h4>
                            <p><Trans i18nKey="orderComplete.order_number" values={{ id: order?.id }} components={{ b: <b className="text-dark" /> }} /></p>
                            <p><Trans i18nKey="orderComplete.see_order_history" components={{ link: <Link to={isAppRoute ? '/app/home/student' : '/home/student'} /> }} /></p>
                        </>
                    }
                </div>
            </div>
        </>
    )
}